<template>
  <div class='hospital-list-wrap'>
    <div v-if="initHosp.enableMind === true">
      <div class='header'>
        <div class="title">心理健康关怀</div>
        <div class="sub-title">缓解焦虑 应对时疫</div>
      </div>
      <div class="header-bottom">
        如果你焦虑不安、失眠、烦躁，请点击
        <a
          class="detail"
          @click="goPsycholist"
        >
          免费咨询心理专家
          <i class="icon-arrow"></i>
        </a>
      </div>
    </div>
    <div class='common-content-wrap'>
      <div class='common-block'></div>
      <div class='clinic-cont'>
        <div class='hosp-list'>
          <div class='title'>在线免费咨询平台</div>
          <SearchInput
            inputColor='gray'
            placeholder='请输入医院名称'
            @on-input='searchByInput'
            @on-clear='searchByInput'
          />
          <SliderBar
            :dataList='sliderList'
            @on-select='selectFilter'
            v-if="this.initHosp.areaCode && sliderList && sliderList.length>0"
          />
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-immediate-check="false"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
          >
            <ul>
              <li
                v-for='(item, i) in result'
                :key='i'
                @click="goCounselor(item)"
              >
                <div class='hosp-info'>
                  <img
                    :src="item.medicalIcon ? item.medicalIcon : defaultUrl"
                    class='img'
                  />
                  <div>
                    <h3 class='txt-name'>{{item.name}}</h3>
                    <p>{{item.hospLevel}}</p>
                  </div>
                </div>
                <div class='arrow-btn'>
                  <i class='icon-arrow-right'></i>
                </div>
              </li>
              <li v-if="result.length === 0">未匹配到结果</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <SuspensionTips :version='version' />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchInput from '@/components/common/SearchInput'
import SliderBar from '@/components/common/SliderBar'
import SuspensionTips from '@/components/common/SuspensionTips'
import api from '@/config/api'

export default {
  components: {
    SearchInput: SearchInput,
    SliderBar: SliderBar,
    SuspensionTips: SuspensionTips
  },
  data () {
    return {
      version: api.version,
      defaultUrl: require('../../assets/images/consult-menu/icon-default-hospital.png'),
      sliderList: [],
      content: '',
      areaCode: '',
      hospFlag: '',
      pageNo: 1,
      rows: 20,
      result: [],
      timer: null,
      loading: false,
      allLoaded: false,
      isFirstLoad: true
    }
  },
  computed: {
    ...mapGetters([
      'initHosp'
    ])
  },
  created () {
    // 初始化为单院时
    if (this.initHosp.mode === '1') {
      this.$router.push({ path: '/counselor' })
    }
    // 初始化为具有区筛选时
    if (this.initHosp.areaCode) {
      this.getFilterList()
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    async search (data) {
      this.allLoaded = false
      this.result = []
      this.pageNo = 1
      this.content = data
      this.getHospList(true)
    },
    searchByInput (data) {
      this.allLoaded = false
      this.result = []
      this.pageNo = 1
      this.content = data

      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getHospList(true)
      }, 1000)
    },
    getFilterList () {
      let initArea = [
        { name: '全部', code: '' }
      ]
      this.sliderList = []

      this.$http.getFilterList({
        parentCode: this.initHosp.areaCode
      }).then(res => {
        if (res && res.length > 0) {
          this.sliderList = [...initArea, ...res]
        }
      }).catch(err => {
        console.log(err)
      })
    },
    selectFilter (data) {
      this.allLoaded = false
      this.result = []
      this.pageNo = 1
      this.areaCode = data
      this.getHospList(true)
    },
    getHospList (clearable) {
      this.loading = true

      this.$http.getHospList({
        content: this.content,
        areaCode: this.areaCode,
        hospFlag: this.hospFlag
      }, {
        pageNo: this.pageNo,
        rows: this.rows
      }).then(res => {
        if (res && res.length > 0) {
          this.result = clearable ? res : [...this.result, ...res]
          this.pageNo++
        } else {
          if (clearable) {
            this.result = []
          }
        }

        if (res.length < this.rows) {
          // if all data are loaded
          this.allLoaded = true
        }
        if (this.isFirstLoad) {
          this.isFirstLoad = false
          // 滚动1像素
          setTimeout(function () {
            window.scrollTo(0, 1)
          }, 300)
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    loadMore () {
      if (this.allLoaded) {
        return false
      }
      this.getHospList(false)
    },
    goCounselor (item) {
      let searchKey = this.$store.getters.searchKey

      searchKey.hosp = {
        phospId: item.phospId,
        name: item.name
      }
      searchKey.dept = {
        phospDeptId: ''
      }
      this.$store.commit('setSearchKey', searchKey)
      this.$router.push({ path: '/counselor' })
    },
    goPsycholist () {
      let searchKey = this.$store.getters.searchKey

      searchKey.hosp = {
        phospId: ''
      }
      searchKey.dept = {
        phospDeptId: ''
      }
      this.$router.push({ path: '/psychologist' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/hospitalList.vue